import { ChangeEvent, KeyboardEventHandler, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Autocomplete } from '@react-google-maps/api'

import { TextInputWithHelper, HelperWrapper } from 'src/components'

interface IProps {
  handleAddress: (address: string) => void
  address: string
  handleLatAndLong: (latAndLong: { lat: number; lng: number }) => void
  error?: string
  withLabel?: boolean
  isDisabled?: boolean
}

const GoogleMapAutocomplete = ({
  handleAddress,
  address,
  handleLatAndLong,
  error,
  withLabel,
  isDisabled,
}: IProps) => {
  const [t] = useTranslation()
  const [autocomplete, setAutocomplete] = useState<google.maps.places.Autocomplete | null>(null)

  const handleAddressChange = (e: ChangeEvent<HTMLInputElement>) => {
    handleAddress(e.target.value)
  }

  const handleAutocompleteLoad = (a: google.maps.places.Autocomplete) => {
    setAutocomplete(a)
  }

  const handleKeyDown: KeyboardEventHandler<HTMLDivElement> = (e) => {
    e.key === 'Enter' && e.preventDefault()
  }

  const handleAutocompletePlaceChanged = () => {
    if (!autocomplete) return
    const place = autocomplete.getPlace()
    place.formatted_address && handleAddress(place.formatted_address)
    if (!place.geometry?.location) return
    handleLatAndLong({
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    })
  }

  return (
    <div>
      <Autocomplete
        onLoad={handleAutocompleteLoad}
        onPlaceChanged={handleAutocompletePlaceChanged}
        options={{ fields: ['formatted_address', 'geometry'] }}
      >
        <TextInputWithHelper
          disabled={isDisabled}
          onKeyDown={handleKeyDown}
          fullWidth
          disableBorder
          inputName={'location_address'}
          error={error}
          inputPlaceholder={t('steps-form-address-input-placeholder.v')}
          inputUpperLabel={
            withLabel ? (
              <HelperWrapper t={'steps-form-address-input-label'} isInputLable />
            ) : undefined
          }
          value={address}
          handleChange={handleAddressChange}
        />
      </Autocomplete>
    </div>
  )
}

export { GoogleMapAutocomplete }
